export default __webpack_public_path__ + "static/media/category3.75ba8a70.svg";